<!-- 组件说明 -->
<template>
  <a-modal
    :footer="null"
    title="群详情"
    :closable="true"
    :visible="showorhidden"
    @cancel="onCloseGroupChat"
    :width="1150"
    :height="600"
  >
    <a-tabs default-active-key="1" @change="callback">
      <a-tab-pane key="1" tab="基本信息">
        <h3>基本信息</h3>
        <div>
          <p>客户群ID：{{ baseData.chat_id ? baseData.chat_id : '--' }}</p>
          <p>
            建群时间：{{ baseData.create_time ? baseData.create_time : '--' }}
          </p>
          <p>群状态：{{ record.status ? record.status : '--' }}</p>
          <p>当前群主：{{ record.ownerName ? record.ownerName : '--' }}</p>
        </div>
        <h3>群公告</h3>
        <div style="margin-bottom:20px;width:750px;">
          {{ baseData.notice ? baseData.notice : '暂无公告' }}
        </div>
      </a-tab-pane>
      <a-tab-pane key="2" tab="群聊话术">
        <a-button @click="showAdd" class="addst" icon="plus">添加话术</a-button>
        <a-table
          :columns="columns2"
          :data-source="dataspeech"
          :pagination="bindPagination"
          @change="bindTableChange"
          :loading="bindLoading"
        >
          <span slot="action" slot-scope="text, record">
            <!-- <a-divider type="vertical" /> -->
            <a-popconfirm
              title="确认删除当前话术吗?"
              ok-text="确认"
              cancel-text="取消"
              @confirm="confirm(record)"
              @cancel="cancel"
            >
              <a type="danger">删除</a>
            </a-popconfirm>
          </span>
        </a-table>
        <a-modal
          title="添加话术"
          :width="600"
          :visible="add"
          @cancel="addCancel"
          @ok="addOk"
        >
          <!-- <a-form :form="form" layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :md="6" :sm="12">
                <a-form-item label="关键词">
                  <a-input placeholder="请输入关键词查询" v-model="queryParam.name"></a-input>
                </a-form-item>
              </a-col>

              <a-col :md="6" :sm="8">
                <a-form-item label="话术分类">
                  <a-select v-model="queryParam.gender" placeholder="请选择话术分类">
                    <a-select-option value="1">群聊话术</a-select-option>
                    <a-select-option value="2">企业话术</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="8">
                <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form> -->
          <a-table
            ref="table"
            size="middle"
            :columns="columns"
            :dataSource="datakeyt"
            :pagination="SPpagination"
            @change="SPhandleTableChange"
            :loading="speechLoading"
            :rowKey="r => r.id"
            :row-selection="{
              selectedRowKeys: selectedRowKeys,
              onChange: onSelectChange
            }"
          >
          </a-table>
        </a-modal>
      </a-tab-pane>
      <a-tab-pane key="3" tab="成员数据">
        <iframe
          :src="iframeUrl1"
          frameborder="0"
          width="1100"
          height="880"
          allowtransparency
        ></iframe>
        <!-- <div style="display:flex;">
          <div class="threespan" style="background: #F759AB;">
            <p>今日新增成员数：</p>
            <p>12人</p>
          </div>
          <div class="threespan" style="background: #F2994A;">
            <p>今日新增成员数：</p>
            <p>12人</p>
          </div>
          <div class="threespan" style="background: #40A9FF;">
            <p>今日新增成员数：</p>
            <p>12人</p>
          </div>
          <div class="threespan" style="background: #36CFC9;">
            <p>今日新增成员数：</p>
            <p>12人</p>
          </div>
        </div>
        <a-tabs default-active-key="11" @change="callback">
          <a-tab-pane key="11" tab="群人数变化">
            <div class="keone" ref="keone" style="width:1126px;height:378px">

            </div>
          </a-tab-pane>
          <a-tab-pane key="2" tab="新增成员">
            群人数变化
          </a-tab-pane>
          <a-tab-pane key="3" tab="退群人数">
            群人数变化
          </a-tab-pane>
          <a-tab-pane key="4" tab="开户人数">
            群人数变化
          </a-tab-pane>
        </a-tabs> -->
      </a-tab-pane>
      <a-tab-pane key="4" tab="消息数据" v-if="iframeUrl2">
        <!-- <div style="display:flex;">
          <div class="threespan" style="background: #F759AB;">
            <p>今日消息总数：</p>
            <p>123</p>
          </div>
          <div class="threespan" style="background: #F2994A;">
            <p>今日客户消息数：</p>
            <p>120</p>
          </div>
          <div class="threespan" style="background: #40A9FF;">
            <p>今日员工消息数：</p>
            <p>12</p>
          </div>
          <div class="threespan" style="background: #36CFC9;">
            <p>累计消息数：</p>
            <p>1234</p>
          </div>
        </div>
        <a-tabs default-active-key="12" @change="callback">
          <a-tab-pane key="12" tab="群人数变化">
            <div class="ketwo" ref="keone" style="width:1126px;height:378px">
            </div>
          </a-tab-pane>
          <a-tab-pane key="2" tab="新增成员">
            群人数变化
          </a-tab-pane>
          <a-tab-pane key="3" tab="退群人数">
            群人数变化
          </a-tab-pane>
          <a-tab-pane key="4" tab="开户人数">
            群人数变化
          </a-tab-pane>
        </a-tabs> -->
        <!-- {{iframeUrl2}} -->
        <iframe
          :src="iframeUrl2"
          frameborder="0"
          width="1100"
          height="880"
          allowtransparency
        ></iframe>
        <!-- <iframe :src="iframeUrl" frameborder="0" width="1100" height="880" allowtransparency></iframe> -->
      </a-tab-pane>
      <a-tab-pane key="5" tab="明细数据">
        <a-button class="addst" @click="toExcel()">导出数据</a-button>
        <a-table
          :columns="columns1"
          :data-source="dataDetail"
          :pagination="ipagination"
          @change="handleTableChange"
          :loading="loading"
        >
        </a-table>
      </a-tab-pane>
      <a-tab-pane key="6" tab="操作留痕">
        <div v-if="actionData.length > 0" style="height:400px;">
          <div
            v-for="(item, index) in actionData"
            :key="index"
            style="marginTop:15px;"
          >
            <span class="ringBox">
              <svg
                t="1622700338680"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="2332"
                width="16"
                height="16"
              >
                <path
                  d="M881.387 297.813c38.08 65.387 57.28 136.747 57.28 214.187s-19.094 148.8-57.28 214.187c-38.187 65.28-89.92 117.12-155.2 155.2S589.44 938.667 512 938.667s-148.8-19.094-214.187-57.28c-65.28-38.08-117.013-89.814-155.306-155.307C104.427 660.8 85.333 589.44 85.333 512c0-77.333 19.094-148.693 57.28-214.187 38.08-65.28 89.814-117.013 155.307-155.306C363.2 104.533 434.56 85.333 512 85.333c77.333 0 148.693 19.094 214.187 57.28 65.28 38.187 117.013 89.92 155.2 155.2z m-217.707-47.36C617.387 223.467 566.827 209.92 512 209.92s-105.387 13.547-151.68 40.533-82.987 63.68-109.973 109.974c-26.987 46.293-40.534 96.853-40.534 151.68s13.547 105.386 40.534 151.68c26.986 46.293 63.68 82.986 109.973 109.973 46.293 26.987 96.853 40.533 151.68 40.533s105.387-13.546 151.68-40.533c46.293-26.987 82.987-63.68 109.973-109.973 26.987-46.294 40.534-96.854 40.534-151.68s-13.547-105.387-40.534-151.68c-27.093-46.294-63.786-82.987-109.973-109.974z"
                  p-id="2333"
                  fill="#1296db"
                ></path>
              </svg>
              <p>{{ item.createtime }}</p>
            </span>
            <span class="pBox">{{ item.msg }}</span>
          </div>
        </div>
        <div style="height:400px;marginLeft:10px" v-else>
          暂无操作
        </div>
      </a-tab-pane>
    </a-tabs>
  </a-modal>
</template>

<script>
import jwt from 'jsonwebtoken';
import {
  getChatDetail,
  getActRecordByChatId,
  getDetailDataList,
  getGroupChatDataList,
  countByGroupChatListToExcel,
  selectSpeechcraftMessage,
  addSpeechcraftMessage,
  delSpeechcraftMessage,
  getAppointGroupChatBindGroupSpeechcrafts
} from '@/api/api';
import { axios } from '@/utils/request';

import * as echarts from 'echarts';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}
const columns = [
  {
    title: '话术类型',
    dataIndex: 'typeName',
    align: 'center'
  },
  {
    title: '话术分类',
    dataIndex: 'categoryName',
    align: 'center'
  },
  {
    title: '话术简述',
    dataIndex: 'description',
    align: 'center'
  },
  {
    title: '累计使用 ',
    dataIndex: 'speechcraftCount',
    align: 'center',
    sorter: (a, b) => a.speechcraftCount - b.speechcraftCount
  },
  {
    title: '近一月使用',
    dataIndex: 'nearlyaMonthCount',
    align: 'center',
    sorter: (a, b) => a.nearlyaMonthCount - b.nearlyaMonthCount
  }
];
const columns1 = [
  {
    title: '时间',
    dataIndex: 'rq',
    align: 'center'
  },
  {
    title: '新增成员',
    dataIndex: 'addUserNum',
    align: 'center'
  },
  {
    title: '退群人数',
    dataIndex: 'delUserNum',
    align: 'center'
  },
  {
    title: '群成员总数',
    dataIndex: 'userNum',
    align: 'center'
  },
  {
    title: '当日消息',
    align: 'center',
    dataIndex: 'todayNum'
  },
  {
    title: '当日客户消息',
    align: 'center',
    dataIndex: 'guestInfoNum'
  },
  {
    align: 'center',
    title: '当日员工消息',
    dataIndex: 'staffInfoNum'
  },
  {
    align: 'center',
    title: '累计消息',
    dataIndex: 'countInfoNum'
  }
];
const columns2 = [
  {
    title: '话术类型',
    dataIndex: 'typeName',
    align: 'center'
  },
  {
    title: '分类',
    dataIndex: 'categoryName',
    align: 'center'
  },
  {
    title: '话术简述',
    dataIndex: 'description',
    align: 'center'
  },
  {
    title: '本群使用次数',
    dataIndex: 'currentGroupChatUseCount',
    align: 'center'
  },
  {
    title: '累计使用次数',
    dataIndex: 'accumulativeUseCount',
    align: 'center'
  },
  {
    title: '操作',
    dataIndex: 'action',
    align: 'center',
    scopedSlots: {
      customRender: 'action'
    }
  }
];
export default {
  props: ['showorhidden', 'record'],
  // mixins: [JeecgListMixin],
  components: {},
  data() {
    return {
      METABASE_SITE_URL: process.env.VUE_APP_METABASE_URL,
      METABASE_SECRET_KEY: process.env.VUE_APP_METABASESECRETKEYINFORMATION,
      METABASE_SECRET_KEY1: process.env.VUE_APP_METABASESECRETKEYPOP,
      previewVisible: false,
      previewImage: '',
      fileList: [
        {
          uid: '-1',
          name: 'image.png',
          status: 'done',
          url:
            'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png'
        },
        {
          uid: '-2',
          name: 'image.png',
          status: 'done',
          url:
            'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png'
        },
        {
          uid: '-5',
          name: 'image.png',
          status: 'error'
        }
      ],
      columns,
      columns1,
      columns2,
      loading: false,
      pagination: {},
      datakeyt: [],
      dataDetail: [],
      dataspeech: [],
      key: '',
      add: false,
      url: {},
      baseData: {},
      actionData: [],
      createTime: '',
      speechLoading: false,
      bindLoading: false,
      selectedRowKeys: [],
      selectionRows: [],
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      SPpagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      bindPagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      }
      // iframeUrl:`http://metabase.ngrok.aresoft.com/public/dashboard/74d4d62a-ac98-46ce-8b8c-12f51e982cba`,
      // iframeUrl2:'http://metabase.ngrok.aresoft.com/public/dashboard/b7f157ec-52b7-4d68-af12-5a760255a9e2'
    };
  },
  computed: {
    //   iframeUrl() {
    //     return `http://metabase.ngrok.aresoft.com/public/dashboard/74d4d62a-ac98-46ce-8b8c-12f51e982cba?chatid=${this.record.chat_id}&createtime=${this.createTime}`
    //   },
    // 成员
    iframeUrl1() {
      console.log(this.record.chat_id, this.createTime);
      let payload = {
        resource: {
          dashboard: +process.env.VUE_APP_METABASEDASHBOARDPOP // 168
        },
        params: {
          chatid: this.record.chat_id
        },
        exp: Math.round(Date.now() / 1000) + 10 * 60 // 10 minute expiration
      };
      let token = jwt.sign(payload, this.METABASE_SECRET_KEY1);
      let iframeUrl =
        this.METABASE_SITE_URL +
        '/embed/dashboard/' +
        token +
        '#bordered=true&titled=true';
      // return `http://metabase.ngrok.aresoft.com/public/dashboard/b7f157ec-52b7-4d68-af12-5a760255a9e2?chatid=${this.record.chat_id}&createtime=${this.createTime}`
      return iframeUrl;
    },
    // 消息
    iframeUrl2() {
      console.log(this.record.chat_id, this.createTime);
      let payload = {
        resource: {
          dashboard: +process.env.VUE_APP_METABASEDASHBOARDINFORMATION // 169
        },
        params: {
          chatid: this.record.chat_id,
          createtime: this.createTime
        },
        exp: Math.round(Date.now() / 1000) + 10 * 60 // 10 minute expiration
      };
      let token = jwt.sign(payload, this.METABASE_SECRET_KEY);
      let iframeUrl =
        this.METABASE_SITE_URL +
        '/embed/dashboard/' +
        token +
        '#bordered=true&titled=true';
      // return `http://metabase.ngrok.aresoft.com/public/dashboard/b7f157ec-52b7-4d68-af12-5a760255a9e2?chatid=${this.record.chat_id}&createtime=${this.createTime}`
      return iframeUrl;
    }
  },
  watch: {
    showorhidden() {
      this.createTime = this.record.create_time.split(' ')[0];
      console.log(this.createTime);
      this.getDetail();
      this.getGroupChatData();
      this.getActRecord();
      this.getDetailData();
      this.getSpeechcrafts();
    }
  },
  methods: {
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },
    confirm(e) {
      this.del(e);
    },
    cancel(e) {},
    getSpeechcrafts() {
      this.bindLoading = true;
      getAppointGroupChatBindGroupSpeechcrafts({
        groupChatId: this.record.chat_id,
        pageNo: this.bindPagination.current,
        pageSize: this.bindPagination.pageSize
      }).then(res => {
        if (res.success) {
          this.bindLoading = false;
          this.dataspeech = res.result.list;
          this.bindPagination.total = res.result.total;
        } else {
          this.bindLoading = false;
          console.log(res.message);
        }
      });
    },
    del(item) {
      delSpeechcraftMessage({
        groupChatId: this.record.chat_id,
        groupSpeechcrafts: item.id
      }).then(res => {
        if (res.success) {
          this.$message.success('删除成功');
          this.getSpeechcrafts();
        } else {
          this.$message.error('删除失败');
        }
      });
    },
    toExcel() {
      axios({
        url:
          process.env.VUE_APP_CMS_WECHATWORKAPI +
          '/wechatworkapi/cusGroupChat/countByGroupChatListToExcel',
        method: 'post',
        data: {
          chatId: this.record.chat_id,
          createTime: this.createTime,
          pageNo: this.ipagination.current,
          pageSize: this.ipagination.pageSize
        },
        responseType: 'blob'
      }).then(res => {
        // console.log(res);
        // let params = xxx
        // const res = await this.$api.export(params);
        const blob = new Blob([res]); // 把得到的结果用流对象转一下
        let a = document.createElement('a'); //创建一个<a></a>标签
        a.href = URL.createObjectURL(blob); // 将流文件写入a标签的href属性值
        a.download = '明细消息数据.xlsx'; //设置文件名
        a.style.display = 'none'; // 障眼法藏起来a标签
        document.body.appendChild(a); // 将a标签追加到文档对象中
        a.click(); // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
        a.remove(); // 一次性的，用完就删除a标签
      });
    },
    getSpeechcraftMessage() {
      this.speechLoading = true;
      selectSpeechcraftMessage({
        chatId: this.record.chat_id,
        pageNo: this.SPpagination.current,
        pageSize: this.SPpagination.pageSize
      }).then(res => {
        if (res.success) {
          this.speechLoading = false;
          this.datakeyt = res.result.list;
          this.SPpagination.total = res.result.total;
        } else {
          this.speechLoading = false;
          console.log(res.message);
        }
      });
    },
    addCancel() {
      this.add = false;
      this.selectedRowKeys = [];
      this.selectionRows = [];
      this.getSpeechcrafts();
    },
    addOk() {
      console.log(this.selectedRowKeys, 'nnnnnnnnnn');
      addSpeechcraftMessage({
        groupChatId: this.record.chat_id,
        groupSpeechcraftIds: this.selectedRowKeys.join(',')
      }).then(res => {
        if (res.success) {
          this.add = false;
          this.selectedRowKeys = [];
          this.selectionRows = [];
          this.getSpeechcrafts();
        }
      });
    },
    getGroupChatData() {
      getGroupChatDataList({
        chat_id: this.record.chat_id
      }).then(res => {});
    },
    getDetail() {
      console.log(this.record);
      getChatDetail({
        chat_id: this.record.chat_id
      }).then(res => {
        this.baseData = res.group_chat;
      });
    },
    getActRecord() {
      getActRecordByChatId({
        chatId: this.record.chat_id
      }).then(res => {
        this.actionData = res;
      });
    },
    getDetailData() {
      this.loading = true;
      getDetailDataList({
        chatId: this.record.chat_id,
        createTime: this.createTime,
        pageNo: this.ipagination.current,
        pageSize: this.ipagination.pageSize
      }).then(res => {
        this.ipagination.total = res.totalPages;
        this.dataDetail = res.list;
        this.loading = false;
      });
    },
    showAdd() {
      this.add = true;
      this.getSpeechcraftMessage();
    },
    onCloseGroupChat() {
      this.$emit('ok');
    },
    callback(key) {
      this.key = key;
      if (key == 1) {
        this.showechats('keone');
        this.showechats('ketwo');
      }
      if (key == 11) {
        this.showechats('keone');
      } else if (key == 12) {
        this.showechats('ketwo');
      }
    },
    handleCancel() {
      this.previewVisible = false;
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    handleChange({ fileList }) {
      this.fileList = fileList;
    },
    showechats(what) {
      console.log('++++++++++++++++++++++++++++++++++++++++++');
      let ke = document.querySelector(`.${what}`);
      let myChart = echarts.init(ke);
      let option;

      option = {
        xAxis: {
          type: 'category',
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: [120, 200, 150, 80, 70, 110, 130],
            type: 'bar'
          }
        ]
      };

      option && myChart.setOption(option);
    },
    handleTableChange(pagination, filters, sorter) {
      this.tableChange(
        pagination,
        filters,
        sorter,
        this.getDetailData,
        'ipagination'
      );
    },
    SPhandleTableChange(pagination, filters, sorter) {
      this.tableChange(
        pagination,
        filters,
        sorter,
        this.getSpeechcraftMessage,
        'SPpagination'
      );
    },
    bindTableChange(pagination, filters, sorter) {
      this.tableChange(
        pagination,
        filters,
        sorter,
        this.getSpeechcrafts,
        'bindPagination'
      );
    },
    tableChange(pagination, filters, sorter, fun, newpag) {
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }
      // newpag = pagination;
      this[newpag] = pagination;
      fun();
    }
  },
  mounted() {}
};
</script>

<style scoped>
.addst {
  margin-bottom: 20px;
  /* display: block;
    width: 102px;
    height: 32px;
    background: #FFFFFF;
    color: #40A9FF;
    border: 1px solid #40A9FF;
    box-sizing: border-box;
    box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.016);
    border-radius: 2px;
    margin-bottom: 15px; */
}

.threespan {
  width: 265px;
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: 20px;
  font-weight: 600;
}

.ringBox {
  margin-left: 20px;
  display: flex;
}

.ringBox p {
  margin-left: 10px;
  margin-top: -3px;
}

.pBox {
  margin-top: -5px;
  margin-left: 40px;
  padding: 2px 10px 1px 10px;
  border-bottom: 2px solid rgba(182, 182, 182, 0.8);
  background: rgb(230, 230, 230);
}
</style>
